import React from "react";
import "./LabeledIcon.css";

const LabeledIcon = (props) => {
  const { svg, label, handleClick } = props;

  return (
    <div
      className="labeled-icon-container"
      onClick={handleClick}
      style={{ display: "flex", cursor: "pointer" }}
    >
      <span className="icon">{svg}</span>
      <span
        className="label"
        style={{
          marginLeft: "5px",
          fontFamily: "Noto Sans, sans-serif !important",
          color:"#2B244C"
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default LabeledIcon;
